export default {
  cat_all: 'Todos',
  cat_beef: 'Res',
  cat_pork: 'Cerdo',
  cat_chicken: 'Pollo',
  cat_goat: 'Chivo',
  cat_seafood: 'Mariscos',

  nav_home: 'Inicio',
  nav_catalog: 'Catálogo',
  nav_about: 'Nosotros',
  nav_testimonials: 'Testimonios',
  nav_contact: 'Contacto',
  nav_visit: 'Visítanos',

  hero_badge: 'Carnicería Premium en Manhattan',
  hero_title_line1: 'Auténticos Cortes Latinos',
  hero_title_line2: 'en el Corazón de Manhattan',
  hero_subtitle:
    'Los mejores cortes frescos para la cocina caribeña y latina. Mondongo, chivo, chicharrón, pernil y todo lo que necesita tu mesa dominicana y puertorriqueña.',
  hero_cta_explore: 'Ver Cortes',
  hero_cta_story: 'Conócenos',
  hero_stat_suppliers: 'Proveedores Premium',
  hero_stat_cuts: 'Cortes Distintos',
  hero_stat_clients: 'Clientes Felices',

  catalog_badge: 'Nuestro Catálogo',
  catalog_title: 'Cortes Frescos Diarios',
  catalog_desc:
    'Carnes frescas seleccionadas para la cocina latina. Desde mondongo hasta chivo, pernil y pescado fresco.',
  catalog_coming_soon: 'Próximamente',
  catalog_empty: 'No hay productos en esta categoría por ahora.',
  catalog_price_disclaimer: '* Todos los precios mostrados son referenciales y están sujetos a variación según el mercado. Consulta el precio actual directamente en la tienda o por WhatsApp.',

  about_badge: 'Sobre Nosotros',
  about_title: 'Sabor Auténtico,',
  about_title_highlight: 'Cortes Reales',
  about_desc:
    'En L&J PREMIUM MEATS LLC llevamos los sabores de casa a tu mesa en Manhattan. Somos una carnicería latina familiar que entiende lo que necesita tu cocina: mondongo para la sopa, pernil para la Navidad, chivo para la fiesta, y chicharrón para el domingo.',
  about_stat_suppliers: 'Proveedores Certificados',
  about_stat_farms: 'Proveedores Locales',
  about_stat_accepted: 'Carnes Frescas',

  feat_sustainability: 'Frescura Garantizada',
  feat_sustainability_desc:
    'Carnes frescas todos los días. Recibimos producto nuevo cada mañana para tu familia.',
  feat_quality: 'Calidad Siempre',
  feat_quality_desc:
    'Seleccionamos cada corte a mano. Solo el mejor producto llega a tu mesa.',
  feat_fresh: 'Cortes Diarios',
  feat_fresh_desc:
    'Molido fresco diario. Pernil marinado, chuletas listas para la parrilla.',
  feat_origin: 'Sabor de Casa',
  feat_origin_desc:
    'Los cortes que conocemos de la cocina dominicana, puertorriqueña y latina.',

  cert_title: 'Certificado',
  cert_desc: 'USDA Inspected. Carnicería autorizada y regulada.',

  testimonials_badge: 'Testimonios',
  testimonials_title: 'Lo que Dice Nuestra Gente',
  testimonials_subtitle:
    'La confianza de nuestra comunidad es lo que nos impulsa cada día. Clientes latinos que vuelven por la calidad.',

  trust_usda: 'USDA Inspected',
  trust_eco: 'Cortes Diarios',
  trust_delivery: 'Entrega Local',
  trust_antibiotics: 'Fresco Siempre',

  cta_title: 'Visítanos Hoy',
  cta_title_highlight: 'en Manhattan',
  cta_desc:
    'Ven a conocer nuestro local. Javier, Luisa y Henry te esperan con los mejores cortes frescos. ¡Lleva el sabor de casa a tu mesa!',
  cta_map: 'Ver Ubicación',
  cta_call: 'Llamar Ahora',

  info_hours: 'Horario',
  info_hours_week: 'Lun - Sáb: 8am - 7pm',
  info_hours_sun: 'Dom: 9am - 3pm',
  info_address: 'Dirección',
  info_phone: 'Teléfono',
  info_whatsapp: 'WhatsApp / Texto',

  footer_desc:
    'Auténticos cortes latinos en Manhattan. Frescura, calidad y el sabor de casa.',
  footer_nav: 'Navegación',
  footer_popular: 'Cortes Populares',
  footer_contact: 'Contacto',

  footer_privacy: 'Privacidad',
  cta_whatsapp: 'Escribir por WhatsApp',
  footer_copyright: '© 2026 L\u0026J Premium Meats. Todos los derechos reservados.',

  badge_best_seller: 'Más Vendido',
  badge_popular: 'Popular',
  badge_specialty: 'Especialidad',
  badge_fresh: 'Fresco Diario',

  // Product names
  prod_costilla_res: 'Costilla de Res',
  prod_rabo: 'Rabo',
  prod_costilla_cerdo: 'Costilla de Cerdo',
  prod_pernil: 'Pernil',
  prod_pata_vaca: 'Pata de Vaca',
  prod_bistec: 'Bistec (Top Round)',
  prod_carne_molida: 'Carne Molida',
  prod_chuleta: 'Chuleta',
  prod_chivo: 'Chivo',
  prod_bola_res: 'Bola de Res',
  prod_mondongo: 'Mondongo',
  prod_orejita: 'Orejita',
  prod_higado: 'Hígado',
  prod_masita: 'Masita de Cerdo',
  prod_chicharron: 'Chicharrón',
  prod_churrasco: 'Churrasco',
  prod_pechuga: 'Pechuga',
  prod_ala_pollo: 'Ala de Pollo',
  prod_gallina: 'Gallina',
  prod_muslo: 'Muslo',
  prod_pollo_entero: 'Pollo Entero',
  prod_molleja: 'Molleja',
  prod_ala_pavo: 'Ala de Pavo',
  prod_basa: 'Basa',
  prod_pescado: 'Pescado',

  // Product descriptions
  desc_costilla_res:
    'Costillas de res frescas con hueso, perfectas para guisos, sopas y asados.',
  desc_rabo:
    'Rabo de res ideal para sancocho, rabo encendido y sopas tradicionales.',
  desc_costilla_cerdo:
    'Costillas de cerdo tiernas para guisar o asar a la parrilla.',
  desc_pernil:
    'Pernil de cerdo entero, perfecto para la Navidad y reuniones familiares.',
  desc_pata_vaca:
    'Pata de vaca con hueso, ideal para sopas y caldos nutritivos.',
  desc_bistec:
    'Bistec de res cortado fino, ideal para bistec encebollado y salteados.',
  desc_carne_molida:
    'Carne molida fresca diaria, perfecta para albondigas, empanadas y pastelón.',
  desc_chuleta:
    'Chuletas de cerdo con hueso, listas para la parrilla o guisadas.',
  desc_chivo:
    'Chivo fresco, el corte esencial para la fiesta y la celebración latina.',
  desc_bola_res:
    'Bola de res para guisar, ideal para carne mechada y estofados.',
  desc_mondongo:
    'Mondongo de res limpio y fresco, el ingrediente estrella del sancocho.',
  desc_orejita:
    'Orejita de cerdo fresca para guisar, ideal para tacos y sopas.',
  desc_higado:
    'Hígado de res fresco, rico en hierro y perfecto para guisar.',
  desc_masita:
    'Masita de cerdo para fritar, el toque crocante de la cocina caribeña.',
  desc_chicharron:
    'Chicharrón fresco y crocante, directo de la fritura a tu mesa.',
  desc_churrasco:
    'Churrasco de res marinado, ideal para la parrilla dominicana.',
  desc_pechuga:
    'Pechuga de pollo fresca, sin hueso, lista para filetear o guisar.',
  desc_ala_pollo:
    'Alas de pollo frescas, perfectas para freír o hornear con sazón.',
  desc_gallina:
    'Gallina entera, ideal para sancocho de gallina y sopas de pollo.',
  desc_muslo:
    'Muslo de pollo con hueso, jugoso y perfecto para guisos y arroz.',
  desc_pollo_entero:
    'Pollo entero fresco, listo para asar o guisar con tu receta favorita.',
  desc_molleja:
    'Molleja de pollo fresca, deliciosa frita o guisada con limón.',
  desc_ala_pavo:
    'Alas de pavo grandes y jugosas, perfectas para hornear o guisar.',
  desc_basa:
    'Filete de basa fresco, suave y perfecto para freír o al horno.',
  desc_pescado:
    'Pescado fresco entero, listo para freír con limón y tostones.',

  testimonial_1_text:
    'El pernil de Navidad siempre lo compro aquí. Fresco, bien cortado y con ese sabor de casa que no encuentras en otra carnicería de Manhattan. ¡Recomendado!',
  testimonial_2_text:
    'Como chef dominicano, necesito mondongo fresco y chivo de verdad. Aquí siempre tienen lo que necesito para mi restaurante. Calidad inigualable en la ciudad.',
  testimonial_3_text:
    'La carne molida siempre está fresca, nunca congelada. Hago mis albondigas y empanadas y toda la familia nota la diferencia. El trato familiar es lo mejor.',
  testimonial_4_text:
    'Para mis parrilladas dominicanas, el churrasco y las chuletas de aquí son los mejores. Javier siempre me corta exactamente lo que pido. Servicio de familia.',
  testimonial_5_text:
    'El chivo fresco es difícil de conseguir en Manhattan, pero aquí siempre lo tienen. Para el cumpleaños de mi esposo, el chivo guisado quedó espectacular.',
  testimonial_6_text:
    'El chicharrón es crocante, el pescado fresco y el pernil... ¡ni hablar! Como estar en la carnicería de Santo Domingo. Javier y Henry son unos capos.',
};